/**
 * Реестр отказов, о которых человек уже узнал — тостом, подписью под полем, отдельным экраном.
 *
 * Нужен из-за того, как `mutateAsync` устроен: он отклоняет промис ДАЖЕ когда у мутации есть
 * `onError`. Обработчик показывает ошибку, а отклонение всё равно уходит в никуда, браузер
 * поднимает `unhandledrejection`, и Sentry записывает это уровнем error с `handled: false` — то
 * есть ровно так же, как настоящее падение приложения. За август таких групп набралось столько,
 * что в списке ошибок стало нечего искать.
 *
 * Расставлять `.catch()` по всем ~70 местам с `mutateAsync` — не выход: это ровно та россыпь
 * try/catch, вместо которой в `queryClient` заведён один обработчик на весь кэш мутаций. Поэтому
 * помечаем сам объект ошибки здесь, а `beforeSend` по этой пометке понижает событие до warning и
 * ставит `handled: true`. Событие не выбрасывается: отбитый шлюзом запрос — это, как правило, баг
 * фронта (так нашлась заявка, уходившая с пустым gameId), и терять его нельзя. Меняется ровно то,
 * чем оно притворялось: не падение, а обработанный отказ.
 *
 * WeakSet, а не поле на ошибке: ничего не добавляет в сериализацию события и не держит объект.
 */
const shownToUser = new WeakSet<object>();

const isObject = (value: unknown): value is object => typeof value === 'object' && value !== null;

export const markErrorShownToUser = (error: unknown) => {
  if (isObject(error)) {
    shownToUser.add(error);
  }
};

export const wasErrorShownToUser = (error: unknown) => isObject(error) && shownToUser.has(error);
